module.exports = __webpack_public_path__ + "static/media/vector_close.402c12d3.svg";